import { Box, styled } from '@mui/material';
import { SECTION_BORDER_WIDTH } from 'src/constants';

export const DisclaimerBox = styled(Box)(
  ({ theme, $scale }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.palette.brand.lightGreen};
  border: ${SECTION_BORDER_WIDTH * $scale}px solid ${
    theme.palette.primary.lightest
  };
  text-align: center;
`,
);

export const RecommendationBox = styled(Box)(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.palette.brand.lightGreen};
  border: 2px solid ${theme.palette.primary.lightest};
  text-align: center;
`,
);

export const ScreenBox = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
`;

export const GridBox = styled(Box)(
  ({ theme, $scale }) => `
  border: ${SECTION_BORDER_WIDTH * $scale}px solid ${
    theme.palette.primary.lightest
  };
`,
);
